import * as i18n from "@solid-primitives/i18n";
import { makePersisted } from "@solid-primitives/storage";
import { createResource, createSignal } from "solid-js";

const i18n_default = {
  greetings: {
    hello: "hello {{ name }}!",
    hi: "hi!",
  },
  goodbye: (name: string) => `goodbye ${name}!`,
  adGoodbye: (obj: { name: string; age: number }) =>
    `goodbye ${obj.name} (${obj.age})!`,
};

export enum Locale {
  US = "us",
  FR = "fr",
}

const dicts = {
  [Locale.US]: i18n_default,
  [Locale.FR]: {
    greetings: {
      hello: "bonjour {{ name }}, comment vas-tu ?",
      hi: "salut!",
    },
    goodbye: (name: string) => `au revoir ${name}!`,
    adGoodbye: (obj: { name: string; age: number }) =>
      `au revoir ${obj.name} (${obj.age})!`,
  },
};

export const [locale, setLocale] = makePersisted(
  createSignal<Locale>(Locale.US),
  {
    name: "i18n-locale",
    storage: localStorage,
  },
);

export const [dict] = createResource(locale, (locale: Locale) => {
  return i18n.flatten(dicts[locale]);
});

export const t = i18n.translator(() => dict.latest, i18n.resolveTemplate);
export const chained = i18n.chainedTranslator(i18n_default, t);

export function createLocalI18n<T extends i18n.BaseRecordDict>(
  i18nDefaultDict: T,
  i18nLocalDicts: Record<Locale, T>,
) {
  const [i18nLocalDict] = createResource(locale, (locale) => {
    return i18n.flatten(i18nLocalDicts[locale]);
  });

  const localT = i18n.translator(
    () => i18nLocalDict.latest,
    i18n.resolveTemplate,
  );

  const localChained = i18n.chainedTranslator(i18nDefaultDict, localT);

  return { localT, localChained };
}
